module.exports = __webpack_public_path__ + "static/img/5.0a2f46c0.png";